/* import __COLOCATED_TEMPLATE__ from './playground-layout.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { type SplitInstance } from 'embercom/modifiers/resizable';

interface Signature {
  Args: {
    isDetailsModuleOpen: boolean;
  };
  Element: HTMLDivElement;
  Blocks: {
    default: [];
  };
}

export default class PlaygroundLayout extends Component<Signature> {
  splitInstance: SplitInstance | undefined = undefined;

  @action
  loadSplitInstance(splitInstance: SplitInstance) {
    this.splitInstance = splitInstance;
  }

  @action
  clearSplitInstance() {
    this.splitInstance = undefined;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::PlaygroundLayout': typeof PlaygroundLayout;
  }
}
